<!--div *ngIf="Settings.GraphType == 1">
    <app-sem-graph-pie></app-sem-graph-pie>
</div>

<div *ngIf="Settings.GraphType == 2">
    <div *ngIf="model.Bar">
        <app-sem-graph-bar [(model)]="model[Settings.BindingPropertyName]"></app-sem-graph-bar>
    </div>
</div>

<div *ngIf="Settings.GraphType == 3">
    <app-sem-graph-donut></app-sem-graph-donut>
</div-->